import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCarussel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"carussel, slides"} maskId="square-filled-radius-0-stroke-1-IconCarussel"><path fillRule="evenodd" clipRule="evenodd" d="M5 3H19V5H22V19H19V21H5V19H2V5H5V3ZM19 6V18H21V6H19ZM5 18V6H3V18H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCarussel;
